export default {"src":"/uk/_next/static/media/Arrow-Right.8132d629.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};